/**
 * @generated SignedSource<<0a64957073584b93e88bd637bf1a59b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type liveArticleQuery$variables = {
  entityUuid?: string | null;
  randomString?: string | null;
};
export type liveArticleQuery$data = {
  readonly liveArticle: {
    readonly " $fragmentSpreads": FragmentRefs<"contentLiveArticleLiveArticle" | "hooksLiveArticleLiveArticle" | "liveUpdateSwitchLiveArticleLiveArticle">;
  } | null;
};
export type liveArticleQuery = {
  response: liveArticleQuery$data;
  variables: liveArticleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityUuid"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "randomString"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityUuid",
        "variableName": "entityUuid"
      },
      {
        "kind": "Variable",
        "name": "randomString",
        "variableName": "randomString"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "liveArticleQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LiveArticle",
        "kind": "LinkedField",
        "name": "liveArticle",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "liveUpdateSwitchLiveArticleLiveArticle"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "hooksLiveArticleLiveArticle"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "contentLiveArticleLiveArticle"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "liveArticleQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LiveArticle",
        "kind": "LinkedField",
        "name": "liveArticle",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pushNotifications",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LiveContent",
            "kind": "LinkedField",
            "name": "liveContents",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entityUuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customTime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entityId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Author",
                "kind": "LinkedField",
                "name": "authors",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FormattedValue",
                "kind": "LinkedField",
                "name": "body",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "json",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "95a917bf0a435c9f2958eeb6dd2e9538",
    "id": null,
    "metadata": {},
    "name": "liveArticleQuery",
    "operationKind": "query",
    "text": "query liveArticleQuery(\n  $entityUuid: String\n  $randomString: String\n) {\n  liveArticle(filter: {entityUuid: $entityUuid, randomString: $randomString}) {\n    ...liveUpdateSwitchLiveArticleLiveArticle\n    ...hooksLiveArticleLiveArticle\n    ...contentLiveArticleLiveArticle\n    id\n  }\n}\n\nfragment contentLiveArticleLiveArticle on LiveArticle {\n  status\n}\n\nfragment hooksLiveArticleLiveArticle on LiveArticle {\n  liveContents {\n    entityUuid\n    customTime\n    entityId\n    ...itemLiveArticleContentLiveContent\n    ...itemLiveArticleTimelineLiveContent\n  }\n}\n\nfragment itemLiveArticleContentLiveContent on LiveContent {\n  entityId\n  title\n  authors {\n    name\n    id\n  }\n  body {\n    json\n  }\n  customTime\n}\n\nfragment itemLiveArticleTimelineLiveContent on LiveContent {\n  entityId\n  title\n  customTime\n}\n\nfragment liveUpdateSwitchLiveArticleLiveArticle on LiveArticle {\n  status\n  pushNotifications\n}\n"
  }
};
})();

(node as any).hash = "49c5edac612ec7e0f268a471b30ca332";

export default node;
